import { render, staticRenderFns } from "./FooterBox.vue?vue&type=template&id=40d2bcaa&scoped=true"
import script from "./FooterBox.vue?vue&type=script&lang=js"
export * from "./FooterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2bcaa",
  null
  
)

export default component.exports